import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Input,
    Typography,
    useMediaQuery,
    Grid
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import IOSSwitchComponent from '../switch/iso-style-switch';
import { DisabledByDefault } from '@mui/icons-material';
import useServices from '../../hooks/useServices';

const isMobileClient = () =>
    typeof navigator !== 'undefined' &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
        navigator.userAgent || ''
    );

const resolvePdfIframeSrc = (url = '') => {
    if (!url) {
        return url;
    }

    const cleanUrl = String(url).split('#')[0];
    if (isMobileClient()) {
        // Mobile browsers/WebViews cannot reliably render PDF in a direct iframe.
        return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(cleanUrl)}`;
    }

    return `${cleanUrl}#toolbar=0&navpanes=0&scrollbar=0`;
};

const StudentResultModel = ({resultURL="",openModel,setIsModelOpen=()=>{},setSelectedPDFUrl }) => {
    const [open, setOpen] = useState(false);
     const [userDetails, setUserDetails] = useState([]);
       // State to manage editable fields
    const [isEditing, setIsEditing] = useState([]);
    const [services] = useServices()


    

    useEffect(() => {
        setOpen(openModel);
       // console.log(services);
    }, [openModel]);



  

    const handleClose = () => {
        setOpen(false);
        setIsModelOpen(false);
        setSelectedPDFUrl(null)
    };



    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen size is small
    const pdfViewerHeight = isMobile || isMobileClient() ? '70vh' : '3500px';

 
    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth={isMobile ? 'xs' : 'md'} fullWidth>
                <DialogTitle>Result</DialogTitle>
                <DialogContent>
                        {resultURL != null && (
                            <div style={{ position: "relative", width: "100%", height: pdfViewerHeight, minHeight: 420 }}>
                            <iframe
                                src={resolvePdfIframeSrc(resultURL)}
                                width="100%"
                                height="100%"
                                title="PDF Viewer"
                                style={{ border: "none" }}
                                allow="fullscreen"
                            ></iframe>
                            {!isMobileClient() && (
                            <div
                                style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "transparent",
                                }}
                                onContextMenu={(e) => e.preventDefault()}
                            ></div>
                            )}
                            </div>
                        )}
                        
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                  

                </DialogActions>
            </Dialog>
        </div>
    );
};

export default StudentResultModel;
